module.exports = __webpack_public_path__ + "assets_app/img/key_5.7c84320d.svg";